export const TIME_FRAMES = [
    {
        name: 'This Week',
        value: 'this week'
    },
    {
        name: 'Next 7 Days',
        value: 'next 7 days'
    },
    {
        name: 'Next Week',
        value: 'next week'
    },
    {
        name: 'Next 2 Weeks',
        value: 'next 2 weeks'
    },
    {
        name: 'Next 3 Weeks',
        value: 'next 3 weeks'
    },
    {
        name: 'This Month',
        value: 'this month'
    },
    {
        name: 'Next Month',
        value: 'next month'
    },
    {
        name: 'Next 2 Months',
        value: 'next 2 months'
    },
    {
        name: 'Next 3 Months',
        value: 'next 3 months'
    },
    {
        name: 'Next 4 Months',
        value: 'next 4 months'
    },
    {
        name: 'Next 5 Months',
        value: 'next 5 months'
    },
    {
        name: 'Next 6 Months',
        value: 'next 6 months'
    }
];
